import { PalmettoLogo } from '@palmetto/dsm-components';
import type { ReactNode } from 'react';

import { CustomerDirectPaymentFooter } from './CustomerDirectPaymentFooter';

interface CustomerDirectPaymentPageProps {
  children: ReactNode;
}

export function CustomerDirectPaymentPage({ children }: CustomerDirectPaymentPageProps) {
  return (
    <div data-mode="light">
      <div data-theme="core" className="flex min-h-screen flex-col bg-canvas-default px-24 py-40">
        {/* Logo — pinned to top */}
        <div className="flex justify-center">
          <PalmettoLogo variant="wordmark" />
        </div>

        {children}

        <CustomerDirectPaymentFooter />
      </div>
    </div>
  );
}
